import ApprovalRequestFlow from '@/api/setting/approval-request-flow'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  approvalTypes: [],
  approverTypes: [],
  jobTitles: [],
  users: [],
  roles: [],
  parameters: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECIEVED_APPROVAL_TYPES(state, data) {
    state.approvalTypes = data
  },
  RECIEVED_PARAMETERS(state, data) {
    state.parameters = data
  },
  RECIEVED_APPROVER_TYPES(state, data) {
    state.approverTypes = data
  },
  RECIEVED_USERS(state, data) {
    state.users = data
  },
  RECIEVED_ROLES(state, data) {
    state.roles = data
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  RECIEVED_JOB_TITLES(state, data) {
    state.jobTitles = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return ApprovalRequestFlow.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return ApprovalRequestFlow.store(data)
  },
  storeCondition(context, data) {
    return ApprovalRequestFlow.storeCondition(data)
  },
  update(context, { id, data }) {
    return ApprovalRequestFlow.update(id, data)
  },
  enable(context, { id, data }) {
    return ApprovalRequestFlow.enable(id, data)
  },

  fetchMobileRole(context) {
    return ApprovalRequestFlow.getMobileRole().then(response => {
      context.commit('RECIEVED_ROLES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchUser(context) {
    return ApprovalRequestFlow.getUser().then(response => {
      context.commit('RECIEVED_USERS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchJobTitle(context) {
    return ApprovalRequestFlow.getJobTitle().then(response => {
      context.commit('RECIEVED_JOB_TITLES', response.data)
      return Promise.resolve(response)
    })
  },

  async fetchResource(context) {
    if (!context.state.approvalTypes.length > 0) {
      let response = await ApprovalRequestFlow.getApprovalType()
      context.commit('RECIEVED_APPROVAL_TYPES', response.data)
    }
    if (!context.state.approverTypes.length > 0) {
      let response = await ApprovalRequestFlow.getApproverType()
      context.commit('RECIEVED_APPROVER_TYPES', response.data)
    }
    if (!context.state.jobTitles.length > 0) {
      let response = await ApprovalRequestFlow.getJobTitle()
      context.commit('RECIEVED_JOB_TITLES', response.data)
    }
  },

  async fetchParameter(context, app_type_id) {
    let response = await ApprovalRequestFlow.getParameters({
      params: { app_type_id: app_type_id }
    })
    context.commit('RECIEVED_PARAMETERS', response.data)
    return response
  }
}
